/**
 * **확대 보기가 덮을 자리** — 셸이 «머리줄 아래 덮어도 되는 본문»에 이 속성을 단다. 영상 확대(`VisionColumn` 의 `useFullView`)가
 * 가장 가까운 이 표지를 찾아 그 칸 크기로 선다. 클래스 이름(`.shell--module .shell__body`)에 묶지 않으려고 둔 표지다.
 *
 * - 통합 콘솔 · 모듈 앱 셸이 단다(eric 2026-10-26 「상위의 헤더는 덮지 말고.. 그 아래만 하게 해줘」)
 * 🔴 통합 콘솔은 **작업 줄 아래 본문**에 단다 — 작업 줄에 E-STOP 이 있어 덮으면 안 된다(07 §6 · 본문 모달 덮개와 같은 범위).
 *    모듈 앱은 E-STOP 이 머리줄에 있어 본문이 곧 «헤더 아래 전부»다
 * - 표지가 없는 셸(장비 관점 · 태블릿 · 패드)은 종전대로 브라우저 전체 화면으로 간다
 */
export const FULL_VIEW_HOST_ATTR = 'data-fullview-host'

export const FULL_VIEW_HOST_SELECTOR = `[${FULL_VIEW_HOST_ATTR}]`

/** JSX 에 펼쳐 다는 값 — `<div {...fullViewHostProps}>` */
export const fullViewHostProps = { [FULL_VIEW_HOST_ATTR]: '' } as const
